<template>
</template>
<script>
  export default {
    name: 'MapboxMarkers',
    data: function() {
      return {
        markers: [], 
        map: null, 
        bounds: null,
      }
    },
    props: ['locations'],
    watch: {
      locations: function(newValues, oldValue){
        var vm = this;
        this.clearAllMarkers;

        vm.$parent.getMap( (map) => {
          this.locations.forEach( (place) => {
            this.setMarker(place, map);
          })
        })

      }
    },
    mounted: function(){
      var vm = this;
      this.bounds = new mapboxgl.LngLatBounds();

      vm.$parent.getMap( (map) => {
        this.locations.forEach( (place) => {
          this.setMarker(place, map);
        })

        this.$parent.map.fitBounds(this.bounds,{padding: 50});
        // this.$parent.map.panTo(this.bounds);

      })

    }, 
    methods: {
      setMarker(location, map){

        var marker = new mapboxgl.Marker()
          .setLngLat([location.latlng.lng,location.latlng.lat])
          .addTo(map)

        this.markers.push(marker);
        this.bounds.extend([location.latlng.lng,location.latlng.lat]);

      }, 
      clearAllMarkers(){

        this.markers.forEach((marker) => {
          // marker.setMap(null);
          this.markers = [];
        })

        // this.bounds = null
      },  
    },
    computed:{

    },
    render(h){
      return null
    }
  }
</script>

<style>
  
</style>